import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { useNavigate } from 'react-router-dom';
import { clientsAPI } from '../../lib/api';

const Clients = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await clientsAPI.getAll();
      setClients(response.data);
    } catch (error) {
      console.error('Error fetching clients:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'company', label: 'Company' },
  { key: 'contact_person', label: 'Primary Contact' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

const formFields = [
  { name: 'name', label: 'Name', required: true, placeholder: 'Client name' },
  { name: 'company', label: 'Company', placeholder: 'Company / legal name, if different' },
  { name: 'contact_person', label: 'Primary Contact Person', placeholder: 'Main person to contact at this client' },
  { name: 'contact_title', label: 'Primary Contact Title', placeholder: 'Job title of the primary contact' },
  { name: 'email', label: 'Email', type: 'email', placeholder: 'client@example.com' },
  { name: 'phone', label: 'Phone', placeholder: '+1-555-0000' },
  { name: 'address', label: 'Address', type: 'textarea', placeholder: 'Full address' },
  { name: 'website', label: 'Website', placeholder: 'https://example.com' },
  { name: 'industry', label: 'Industry', placeholder: 'e.g. Retail, Manufacturing' },
  { name: 'source', label: 'Source', placeholder: 'e.g. Website, Referral' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    defaultValue: 'active',
    options: [
      { value: 'prospect', label: 'Prospect' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
    ],
  },
  {
    name: 'priority',
    label: 'Priority',
    type: 'select',
    defaultValue: 'medium',
    options: [
      { value: 'high', label: 'High' },
      { value: 'medium', label: 'Medium' },
      { value: 'low', label: 'Low' },
    ],
  },
  { name: 'tax_id', label: 'Tax / Registration Number', placeholder: 'Tax or company registration number' },
  {
    name: 'payment_terms',
    label: 'Payment Terms',
    type: 'select',
    options: [
      { value: 'Net 15', label: 'Net 15' },
      { value: 'Net 30', label: 'Net 30' },
      { value: 'Net 60', label: 'Net 60' },
      { value: 'Due on receipt', label: 'Due on receipt' },
    ],
  },
  { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Anything worth remembering about this client' },
];

  const handleAdd = async (data) => {
    await clientsAPI.create(data);
    fetchClients();
  };

  const handleEdit = async (id, data) => {
    await clientsAPI.update(id, data);
    fetchClients();
  };

  const handleDelete = async (id) => {
    await clientsAPI.delete(id);
    fetchClients();
  };

  return (
    <DataTable
      title="Clients"
      description="Customer companies you do business with. People who work at a client are Contacts, managed under CRM > Contacts."
      data={clients}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      customActions={[
        {
          label: 'View Details',
          onClick: (client) => navigate('/crm/clients/' + client.id),
        }
      ]}
      loading={loading}
    />
  );
};

export default Clients;
